const heroHighlights = [
  { icon: "ri-refresh-line", label: "分钟级更新", text: "热度实时滚动" },
  { icon: "ri-flashlight-fill", label: "全网聚合", text: "一键锁定爆点" },
  { icon: "ri-fire-line", label: "热度TOP", text: "当红焦点不遗漏" },
];

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20vibrant%20gradient%20backdrop%20with%20warm%20coral%2C%20orange%20and%20cream%20ink%20splashes%20and%20floating%20fire%20flame%20and%20speech%20bubble%20shapes%2C%20soft%20bokeh%20lights%2C%20energetic%20yet%20smooth%2C%20modern%20editorial%20background%2C%20wide%20composition&width=1800&height=1000&seq=hero-gossip-bg&orientation=landscape"
          alt="吃瓜精选热门榜动态背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/55 via-background-950/40 to-background-50"></div>
      </div>

      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-32 md:pt-40 pb-16 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-6 items-center">
          <div className="lg:col-span-7 text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 backdrop-blur px-3.5 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/30">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
              </span>
              吃瓜精选热门榜 正在实时更新
            </span>

            <h1 className="font-display text-4xl md:text-6xl leading-tight text-background-50 mt-6">
              一榜看尽全网
              <br className="hidden md:block" />
              <span className="text-accent-300"> 当日热度TOP爆款</span>
            </h1>

            <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-background-100/90 mx-auto lg:mx-0">
              吃瓜精选热门榜与本周排行每日滚动更新，从娱乐八卦到社会热点，聚合全网最高话题度的事件。
              实时追踪流量峰值内容，省去翻找时间，帮你随时锁定最新鲜的瓜田动态。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3 items-center justify-center lg:justify-start">
              <a
                href="#today"
                className="whitespace-nowrap inline-flex items-center gap-2 h-12 px-7 rounded-full bg-accent-500 text-background-950 text-sm font-bold hover:bg-accent-400 transition-colors"
              >
                <i className="ri-fire-line text-lg"></i>
                查看今日热门榜
              </a>
              <a
                href="#week"
                className="whitespace-nowrap inline-flex items-center gap-2 h-12 px-7 rounded-full bg-background-50/15 backdrop-blur text-background-50 text-sm font-semibold ring-1 ring-background-50/40 hover:bg-background-50/25 transition-colors"
              >
                本周排行
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 max-w-md mx-auto lg:mx-0">
              {heroHighlights.map((item) => (
                <div
                  key={item.label}
                  className="rounded-xl bg-background-50/10 backdrop-blur px-3 py-4 text-center ring-1 ring-background-50/20"
                >
                  <dt className="sr-only">{item.label}</dt>
                  <dd className="flex flex-col items-center gap-1.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-400/90 text-background-950">
                      <i className={`${item.icon} text-base`}></i>
                    </span>
                    <span className="text-sm font-bold text-background-50 whitespace-nowrap">{item.label}</span>
                    <span className="text-xs text-background-100/80">{item.text}</span>
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <aside className="rounded-2xl bg-background-50/95 backdrop-blur p-5 md:p-6 shadow-soft ring-1 ring-background-200">
              <div className="flex items-center justify-between mb-4">
                <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
                  <i className="ri-flashlight-fill text-primary-600"></i>
                  热度峰值速览
                </h2>
                <a href="#today" className="text-xs text-foreground-500 hover:text-primary-600">
                  完整榜单
                  <i className="ri-arrow-right-line ml-0.5"></i>
                </a>
              </div>
              <ol className="space-y-1">
                {[
                  ["现象级古装剧大结局刷屏", "影视"],
                  ["顶流歌手演唱会开票秒空", "娱乐"],
                  ["夏日避暑新玩法走红", "生活"],
                  ["非遗传承短视频出圈", "文化"],
                ].map(([title, cat], idx) => (
                  <li
                    key={idx}
                    className="group flex items-center gap-3 rounded-lg px-2 py-2.5 hover:bg-primary-50 transition-colors cursor-pointer"
                  >
                    <span className="font-display text-lg w-7 text-center text-foreground-400 group-hover:text-primary-600">
                      {idx + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm text-foreground-900">{title}</p>
                    </div>
                    <span className="shrink-0 text-[11px] text-foreground-400">{cat}</span>
                    <i className="ri-arrow-right-up-line text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition"></i>
                  </li>
                ))}
              </ol>
              <div className="mt-4 flex items-center gap-2 rounded-lg bg-accent-100/70 px-3 py-2.5 text-xs text-accent-800">
                <i className="ri-time-line text-sm shrink-0"></i>
                距下次热度刷新还有 12 分钟
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}